<div class="Screen_Width_Go" style="overflow-x: scroll;">
	<p-tabView (onChange)="handleChange($event)" [activeIndex]="index">
		<p-tabPanel [header]='setLabel("captureImageHeaderLabel")'>
			<div style="text-align:center">
				<div>
					<webcam [height]="500" [width]="500" [trigger]="triggerObservable"
						(imageCapture)="handleImage($event)" *ngIf="showWebcam" [allowCameraSwitch]="allowCameraSwitch"
						[switchCamera]="nextWebcamObservable" [videoOptions]="videoOptions"
						(cameraSwitched)="cameraWasSwitched($event)" (initError)="handleInitError($event)"></webcam>
					<br />
					<p-footer>
						<button pButton type="button" icon="pi pi-plus" [label]='setLabel("takeASnapshotBtnLabel")'
							(click)="triggerSnapshot()" class="ui-button-info" style="margin-right: .25em"></button>
					</p-footer>
				</div>
			</div>
		</p-tabPanel>
		<p-tabPanel [header]='setLabel("cropImageHeaderLabel")'>
			<div class="snapshot" *ngIf="webcamImage">
				<image-cropper [maintainAspectRatio]="true" [aspectRatio]="1 / 1" format="jpeg"
					[imageBase64]="webcamImage.imageAsDataUrl" (imageCropped)="imageCropped($event)"></image-cropper>
				<p-footer>
					<button pButton style="margin-left: 220px;" *ngIf="croppedImage" type="button" icon="pi pi-plus"
						[label]='setLabel("cropPhotoBtnLabel")' (click)="handleChange(index)" class="ui-button-info"
						style="margin-right: .25em"></button>
				</p-footer>
			</div>
		</p-tabPanel>
		<p-tabPanel [header]='setLabel("uploadHeaderLabel")'>
			<div class="snapshot">
				<img *ngIf="croppedImage" [src]="croppedImage" />
			</div>
			<br>
			<p-footer>
				<button pButton *ngIf="croppedImage" type="button" icon="pi pi-plus" [label]='setLabel("savePhotoBtnLabel")'
					(click)="Upload()" class="ui-button-info memberCamptureBtn"></button>
			</p-footer>
		</p-tabPanel>
	</p-tabView>
</div>